import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function LowerSilesian() {
  return (
    <>
      <DisplayMaster voivodeship="LowerSilesian" />
    </>
  );
}